
export default {
    spacingDebug: true,
    props: {
        floating: { type: Boolean, default: false },
        separator: { type: String, default: "/" },
        no_border_bottom: { type: Boolean, default: false },
        light_text: { type: Boolean, default: false },
        font_color: { type: String, default: "" },
        // Optional override to pass rich SEO titles directly from page components
        customCrumbs: { type: Array, default: null },
    },
    data: () => ({
        crumbs: [],
    }),
    computed: {
        populateCrumbs() {
            // If explicit SEO names are provided via props, prioritize them
            if (this.customCrumbs && this.customCrumbs.length) {
                return this.customCrumbs;
            }

            let result = [];
            let path = "";

            for (let i = 0; i < this.crumbs.length; i++) {
                if (i === 0) {
                    result.push({ name: "Home", link: "/" });
                } else {
                    path += `/${this.crumbs[i]}`;
                    result.push({
                        name: this.strDeslugify(this.crumbs[i]),
                        link: path,
                    });
                }
            }
            return result;
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.initialize();
            },
        },
    },
    methods: {
        initialize() {
            const pathArray = this.$route.path.split("/").filter(Boolean);
            this.crumbs = ["", ...pathArray];
        },
        strDeslugify(slug) {
            return slug.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
        },
    },
};
